/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface UsersServicesLiesSearchDto
 */
export interface UsersServicesLiesSearchDto {
    /**
     * 
     * @type {number}
     * @memberof UsersServicesLiesSearchDto
     */
    idUser?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UsersServicesLiesSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof UsersServicesLiesSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof UsersServicesLiesSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UsersServicesLiesSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof UsersServicesLiesSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UsersServicesLiesSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the UsersServicesLiesSearchDto interface.
 */
export function instanceOfUsersServicesLiesSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UsersServicesLiesSearchDtoFromJSON(json: any): UsersServicesLiesSearchDto {
    return UsersServicesLiesSearchDtoFromJSONTyped(json, false);
}

export function UsersServicesLiesSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersServicesLiesSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idUser': !exists(json, 'idUser') ? undefined : json['idUser'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function UsersServicesLiesSearchDtoToJSON(value?: UsersServicesLiesSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idUser': value.idUser,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

